// extracted by mini-css-extract-plugin
export default {"menu-wrapper":"ProjectsSelect_menu-wrapper__qn7fL","menu-input-wrapper":"ProjectsSelect_menu-input-wrapper__Ubvdi","menu-list-wrapper":"ProjectsSelect_menu-list-wrapper__f1PTD"};